module.exports = __webpack_public_path__ + "static/member-segment-0d185cbccee11b02aad111421b064e8c.png";